/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingStartRouteImport } from './routes/onboarding/start'
import { Route as OnboardingEmailVerifyRouteImport } from './routes/onboarding/email-verify'
import { Route as OnboardingAccountRouteImport } from './routes/onboarding/account'
import { Route as OnboardingGuardedRouteImport } from './routes/onboarding/_guarded'
import { Route as AuthenticatedFleetRouteImport } from './routes/_authenticated/fleet'
import { Route as AuthenticatedDriverRouteImport } from './routes/_authenticated/driver'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedFleetIndexRouteImport } from './routes/_authenticated/fleet/index'
import { Route as AuthenticatedDriverIndexRouteImport } from './routes/_authenticated/driver/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as OnboardingGuardedPhoneVerifyRouteImport } from './routes/onboarding/_guarded/phone-verify'
import { Route as OnboardingGuardedPhoneRouteImport } from './routes/onboarding/_guarded/phone'
import { Route as OnboardingGuardedLegalRouteImport } from './routes/onboarding/_guarded/legal'
import { Route as OnboardingGuardedIdentityRouteImport } from './routes/onboarding/_guarded/identity'
import { Route as OnboardingGuardedFormulaConfigRouteImport } from './routes/onboarding/_guarded/formula-config'
import { Route as OnboardingGuardedFormulaRouteImport } from './routes/onboarding/_guarded/formula'
import { Route as OnboardingGuardedFinalRouteImport } from './routes/onboarding/_guarded/final'
import { Route as OnboardingGuardedEmailVerifiedRouteImport } from './routes/onboarding/_guarded/email-verified'
import { Route as OnboardingGuardedDriversLicenseRouteImport } from './routes/onboarding/_guarded/drivers-license'
import { Route as OnboardingGuardedDepositRouteImport } from './routes/onboarding/_guarded/deposit'
import { Route as OnboardingGuardedBillingRouteImport } from './routes/onboarding/_guarded/billing'
import { Route as OnboardingGuardedAddressRouteImport } from './routes/onboarding/_guarded/address'
import { Route as AuthenticatedFleetTripsRouteImport } from './routes/_authenticated/fleet/trips'
import { Route as AuthenticatedFleetReportsRouteImport } from './routes/_authenticated/fleet/reports'
import { Route as AuthenticatedDriverMyTripsRouteImport } from './routes/_authenticated/driver/my-trips'
import { Route as AuthenticatedCardActivationCardNumberRouteImport } from './routes/_authenticated/card-activation/$cardNumber'
import { Route as AuthenticatedAdminVehicleBaseLocationsRouteImport } from './routes/_authenticated/admin/vehicle-base-locations'
import { Route as AuthenticatedAdminTripsRouteImport } from './routes/_authenticated/admin/trips'
import { Route as AuthenticatedAdminSystemStatusRouteImport } from './routes/_authenticated/admin/system-status'
import { Route as AuthenticatedAdminReportsRouteImport } from './routes/_authenticated/admin/reports'
import { Route as AuthenticatedFleetVehiclesIndexRouteImport } from './routes/_authenticated/fleet/vehicles/index'
import { Route as AuthenticatedFleetDriversIndexRouteImport } from './routes/_authenticated/fleet/drivers/index'
import { Route as AuthenticatedFleetBillingIndexRouteImport } from './routes/_authenticated/fleet/billing/index'
import { Route as AuthenticatedAdminVehiclesIndexRouteImport } from './routes/_authenticated/admin/vehicles/index'
import { Route as AuthenticatedAdminVehicleGroupsIndexRouteImport } from './routes/_authenticated/admin/vehicle-groups/index'
import { Route as AuthenticatedAdminUsersIndexRouteImport } from './routes/_authenticated/admin/users/index'
import { Route as AuthenticatedAdminTasksIndexRouteImport } from './routes/_authenticated/admin/tasks/index'
import { Route as AuthenticatedAdminRateCardsIndexRouteImport } from './routes/_authenticated/admin/rate-cards/index'
import { Route as AuthenticatedAdminDriversIndexRouteImport } from './routes/_authenticated/admin/drivers/index'
import { Route as AuthenticatedAdminDamagesIndexRouteImport } from './routes/_authenticated/admin/damages/index'
import { Route as AuthenticatedAdminClientsIndexRouteImport } from './routes/_authenticated/admin/clients/index'
import { Route as AuthenticatedAdminBookingsIndexRouteImport } from './routes/_authenticated/admin/bookings/index'
import { Route as AuthenticatedAdminBillingIndexRouteImport } from './routes/_authenticated/admin/billing/index'
import { Route as AuthenticatedFleetVehiclesVehicleIdRouteImport } from './routes/_authenticated/fleet/vehicles/$vehicleId'
import { Route as AuthenticatedFleetDriversUserIdRouteImport } from './routes/_authenticated/fleet/drivers/$userId'
import { Route as AuthenticatedAdminVehiclesSuspendedRouteImport } from './routes/_authenticated/admin/vehicles/suspended'
import { Route as AuthenticatedAdminVehiclesSchedulerRouteImport } from './routes/_authenticated/admin/vehicles/scheduler'
import { Route as AuthenticatedAdminVehiclesActiveUsagesRouteImport } from './routes/_authenticated/admin/vehicles/active-usages'
import { Route as AuthenticatedAdminVehiclesVehicleIdRouteImport } from './routes/_authenticated/admin/vehicles/$vehicleId'
import { Route as AuthenticatedAdminVehicleGroupsVehicleGroupIdRouteImport } from './routes/_authenticated/admin/vehicle-groups/$vehicleGroupId'
import { Route as AuthenticatedAdminUsersRemoteIdRouteImport } from './routes/_authenticated/admin/users/$remoteId'
import { Route as AuthenticatedAdminRateCardsRateCardIdRouteImport } from './routes/_authenticated/admin/rate-cards/$rateCardId'
import { Route as AuthenticatedAdminDriversUserIdRouteImport } from './routes/_authenticated/admin/drivers/$userId'
import { Route as AuthenticatedAdminClientsClientIdRouteImport } from './routes/_authenticated/admin/clients/$clientId'
import { Route as AuthenticatedAdminBookingsBookingIdRouteImport } from './routes/_authenticated/admin/bookings/$bookingId'
import { Route as AuthenticatedFleetChargingCardsIndexRouteImport } from './routes/_authenticated/fleet/charging/cards/index'
import { Route as AuthenticatedAdminTasksProblematicBookingsIndexRouteImport } from './routes/_authenticated/admin/tasks/problematic-bookings/index'
import { Route as AuthenticatedAdminTasksOverdueIndexRouteImport } from './routes/_authenticated/admin/tasks/overdue/index'
import { Route as AuthenticatedAdminTasksCleaningIndexRouteImport } from './routes/_authenticated/admin/tasks/cleaning/index'
import { Route as AuthenticatedAdminChargingStationsIndexRouteImport } from './routes/_authenticated/admin/charging/stations/index'
import { Route as AuthenticatedAdminChargingSessionsIndexRouteImport } from './routes/_authenticated/admin/charging/sessions/index'
import { Route as AuthenticatedAdminChargingCardsIndexRouteImport } from './routes/_authenticated/admin/charging/cards/index'
import { Route as AuthenticatedFleetChargingCardsCardIdRouteImport } from './routes/_authenticated/fleet/charging/cards/$cardId'
import { Route as AuthenticatedAdminTasksCleaningCleaningIdRouteImport } from './routes/_authenticated/admin/tasks/cleaning/$cleaningId'
import { Route as AuthenticatedAdminChargingSessionsSessionIdRouteImport } from './routes/_authenticated/admin/charging/sessions/$sessionId'
import { Route as AuthenticatedAdminChargingCardsCardIdRouteImport } from './routes/_authenticated/admin/charging/cards/$cardId'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingStartRoute = OnboardingStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingEmailVerifyRoute = OnboardingEmailVerifyRouteImport.update({
  id: '/email-verify',
  path: '/email-verify',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingAccountRoute = OnboardingAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingGuardedRoute = OnboardingGuardedRouteImport.update({
  id: '/_guarded',
  getParentRoute: () => OnboardingRoute,
} as any)
const AuthenticatedFleetRoute = AuthenticatedFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDriverRoute = AuthenticatedDriverRouteImport.update({
  id: '/driver',
  path: '/driver',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFleetIndexRoute = AuthenticatedFleetIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedFleetRoute,
} as any)
const AuthenticatedDriverIndexRoute =
  AuthenticatedDriverIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDriverRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const OnboardingGuardedPhoneVerifyRoute =
  OnboardingGuardedPhoneVerifyRouteImport.update({
    id: '/phone-verify',
    path: '/phone-verify',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const OnboardingGuardedPhoneRoute = OnboardingGuardedPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => OnboardingGuardedRoute,
} as any)
const OnboardingGuardedLegalRoute = OnboardingGuardedLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => OnboardingGuardedRoute,
} as any)
const OnboardingGuardedIdentityRoute =
  OnboardingGuardedIdentityRouteImport.update({
    id: '/identity',
    path: '/identity',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const OnboardingGuardedFormulaConfigRoute =
  OnboardingGuardedFormulaConfigRouteImport.update({
    id: '/formula-config',
    path: '/formula-config',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const OnboardingGuardedFormulaRoute =
  OnboardingGuardedFormulaRouteImport.update({
    id: '/formula',
    path: '/formula',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const OnboardingGuardedFinalRoute = OnboardingGuardedFinalRouteImport.update({
  id: '/final',
  path: '/final',
  getParentRoute: () => OnboardingGuardedRoute,
} as any)
const OnboardingGuardedEmailVerifiedRoute =
  OnboardingGuardedEmailVerifiedRouteImport.update({
    id: '/email-verified',
    path: '/email-verified',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const OnboardingGuardedDriversLicenseRoute =
  OnboardingGuardedDriversLicenseRouteImport.update({
    id: '/drivers-license',
    path: '/drivers-license',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const OnboardingGuardedDepositRoute =
  OnboardingGuardedDepositRouteImport.update({
    id: '/deposit',
    path: '/deposit',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const OnboardingGuardedBillingRoute =
  OnboardingGuardedBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const OnboardingGuardedAddressRoute =
  OnboardingGuardedAddressRouteImport.update({
    id: '/address',
    path: '/address',
    getParentRoute: () => OnboardingGuardedRoute,
  } as any)
const AuthenticatedFleetTripsRoute = AuthenticatedFleetTripsRouteImport.update({
  id: '/trips',
  path: '/trips',
  getParentRoute: () => AuthenticatedFleetRoute,
} as any)
const AuthenticatedFleetReportsRoute =
  AuthenticatedFleetReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedFleetRoute,
  } as any)
const AuthenticatedDriverMyTripsRoute =
  AuthenticatedDriverMyTripsRouteImport.update({
    id: '/my-trips',
    path: '/my-trips',
    getParentRoute: () => AuthenticatedDriverRoute,
  } as any)
const AuthenticatedCardActivationCardNumberRoute =
  AuthenticatedCardActivationCardNumberRouteImport.update({
    id: '/card-activation/$cardNumber',
    path: '/card-activation/$cardNumber',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminVehicleBaseLocationsRoute =
  AuthenticatedAdminVehicleBaseLocationsRouteImport.update({
    id: '/vehicle-base-locations',
    path: '/vehicle-base-locations',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminTripsRoute = AuthenticatedAdminTripsRouteImport.update({
  id: '/trips',
  path: '/trips',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminSystemStatusRoute =
  AuthenticatedAdminSystemStatusRouteImport.update({
    id: '/system-status',
    path: '/system-status',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminReportsRoute =
  AuthenticatedAdminReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedFleetVehiclesIndexRoute =
  AuthenticatedFleetVehiclesIndexRouteImport.update({
    id: '/vehicles/',
    path: '/vehicles/',
    getParentRoute: () => AuthenticatedFleetRoute,
  } as any)
const AuthenticatedFleetDriversIndexRoute =
  AuthenticatedFleetDriversIndexRouteImport.update({
    id: '/drivers/',
    path: '/drivers/',
    getParentRoute: () => AuthenticatedFleetRoute,
  } as any)
const AuthenticatedFleetBillingIndexRoute =
  AuthenticatedFleetBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedFleetRoute,
  } as any)
const AuthenticatedAdminVehiclesIndexRoute =
  AuthenticatedAdminVehiclesIndexRouteImport.update({
    id: '/vehicles/',
    path: '/vehicles/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminVehicleGroupsIndexRoute =
  AuthenticatedAdminVehicleGroupsIndexRouteImport.update({
    id: '/vehicle-groups/',
    path: '/vehicle-groups/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminUsersIndexRoute =
  AuthenticatedAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminTasksIndexRoute =
  AuthenticatedAdminTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminRateCardsIndexRoute =
  AuthenticatedAdminRateCardsIndexRouteImport.update({
    id: '/rate-cards/',
    path: '/rate-cards/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDriversIndexRoute =
  AuthenticatedAdminDriversIndexRouteImport.update({
    id: '/drivers/',
    path: '/drivers/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDamagesIndexRoute =
  AuthenticatedAdminDamagesIndexRouteImport.update({
    id: '/damages/',
    path: '/damages/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminClientsIndexRoute =
  AuthenticatedAdminClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminBookingsIndexRoute =
  AuthenticatedAdminBookingsIndexRouteImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminBillingIndexRoute =
  AuthenticatedAdminBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedFleetVehiclesVehicleIdRoute =
  AuthenticatedFleetVehiclesVehicleIdRouteImport.update({
    id: '/vehicles/$vehicleId',
    path: '/vehicles/$vehicleId',
    getParentRoute: () => AuthenticatedFleetRoute,
  } as any)
const AuthenticatedFleetDriversUserIdRoute =
  AuthenticatedFleetDriversUserIdRouteImport.update({
    id: '/drivers/$userId',
    path: '/drivers/$userId',
    getParentRoute: () => AuthenticatedFleetRoute,
  } as any)
const AuthenticatedAdminVehiclesSuspendedRoute =
  AuthenticatedAdminVehiclesSuspendedRouteImport.update({
    id: '/vehicles/suspended',
    path: '/vehicles/suspended',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminVehiclesSchedulerRoute =
  AuthenticatedAdminVehiclesSchedulerRouteImport.update({
    id: '/vehicles/scheduler',
    path: '/vehicles/scheduler',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminVehiclesActiveUsagesRoute =
  AuthenticatedAdminVehiclesActiveUsagesRouteImport.update({
    id: '/vehicles/active-usages',
    path: '/vehicles/active-usages',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminVehiclesVehicleIdRoute =
  AuthenticatedAdminVehiclesVehicleIdRouteImport.update({
    id: '/vehicles/$vehicleId',
    path: '/vehicles/$vehicleId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminVehicleGroupsVehicleGroupIdRoute =
  AuthenticatedAdminVehicleGroupsVehicleGroupIdRouteImport.update({
    id: '/vehicle-groups/$vehicleGroupId',
    path: '/vehicle-groups/$vehicleGroupId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminUsersRemoteIdRoute =
  AuthenticatedAdminUsersRemoteIdRouteImport.update({
    id: '/users/$remoteId',
    path: '/users/$remoteId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminRateCardsRateCardIdRoute =
  AuthenticatedAdminRateCardsRateCardIdRouteImport.update({
    id: '/rate-cards/$rateCardId',
    path: '/rate-cards/$rateCardId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDriversUserIdRoute =
  AuthenticatedAdminDriversUserIdRouteImport.update({
    id: '/drivers/$userId',
    path: '/drivers/$userId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminClientsClientIdRoute =
  AuthenticatedAdminClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminBookingsBookingIdRoute =
  AuthenticatedAdminBookingsBookingIdRouteImport.update({
    id: '/bookings/$bookingId',
    path: '/bookings/$bookingId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedFleetChargingCardsIndexRoute =
  AuthenticatedFleetChargingCardsIndexRouteImport.update({
    id: '/charging/cards/',
    path: '/charging/cards/',
    getParentRoute: () => AuthenticatedFleetRoute,
  } as any)
const AuthenticatedAdminTasksProblematicBookingsIndexRoute =
  AuthenticatedAdminTasksProblematicBookingsIndexRouteImport.update({
    id: '/tasks/problematic-bookings/',
    path: '/tasks/problematic-bookings/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminTasksOverdueIndexRoute =
  AuthenticatedAdminTasksOverdueIndexRouteImport.update({
    id: '/tasks/overdue/',
    path: '/tasks/overdue/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminTasksCleaningIndexRoute =
  AuthenticatedAdminTasksCleaningIndexRouteImport.update({
    id: '/tasks/cleaning/',
    path: '/tasks/cleaning/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminChargingStationsIndexRoute =
  AuthenticatedAdminChargingStationsIndexRouteImport.update({
    id: '/charging/stations/',
    path: '/charging/stations/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminChargingSessionsIndexRoute =
  AuthenticatedAdminChargingSessionsIndexRouteImport.update({
    id: '/charging/sessions/',
    path: '/charging/sessions/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminChargingCardsIndexRoute =
  AuthenticatedAdminChargingCardsIndexRouteImport.update({
    id: '/charging/cards/',
    path: '/charging/cards/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedFleetChargingCardsCardIdRoute =
  AuthenticatedFleetChargingCardsCardIdRouteImport.update({
    id: '/charging/cards/$cardId',
    path: '/charging/cards/$cardId',
    getParentRoute: () => AuthenticatedFleetRoute,
  } as any)
const AuthenticatedAdminTasksCleaningCleaningIdRoute =
  AuthenticatedAdminTasksCleaningCleaningIdRouteImport.update({
    id: '/tasks/cleaning/$cleaningId',
    path: '/tasks/cleaning/$cleaningId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminChargingSessionsSessionIdRoute =
  AuthenticatedAdminChargingSessionsSessionIdRouteImport.update({
    id: '/charging/sessions/$sessionId',
    path: '/charging/sessions/$sessionId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminChargingCardsCardIdRoute =
  AuthenticatedAdminChargingCardsCardIdRouteImport.update({
    id: '/charging/cards/$cardId',
    path: '/charging/cards/$cardId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingGuardedRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/driver': typeof AuthenticatedDriverRouteWithChildren
  '/fleet': typeof AuthenticatedFleetRouteWithChildren
  '/onboarding/account': typeof OnboardingAccountRoute
  '/onboarding/email-verify': typeof OnboardingEmailVerifyRoute
  '/onboarding/start': typeof OnboardingStartRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/admin/system-status': typeof AuthenticatedAdminSystemStatusRoute
  '/admin/trips': typeof AuthenticatedAdminTripsRoute
  '/admin/vehicle-base-locations': typeof AuthenticatedAdminVehicleBaseLocationsRoute
  '/card-activation/$cardNumber': typeof AuthenticatedCardActivationCardNumberRoute
  '/driver/my-trips': typeof AuthenticatedDriverMyTripsRoute
  '/fleet/reports': typeof AuthenticatedFleetReportsRoute
  '/fleet/trips': typeof AuthenticatedFleetTripsRoute
  '/onboarding/address': typeof OnboardingGuardedAddressRoute
  '/onboarding/billing': typeof OnboardingGuardedBillingRoute
  '/onboarding/deposit': typeof OnboardingGuardedDepositRoute
  '/onboarding/drivers-license': typeof OnboardingGuardedDriversLicenseRoute
  '/onboarding/email-verified': typeof OnboardingGuardedEmailVerifiedRoute
  '/onboarding/final': typeof OnboardingGuardedFinalRoute
  '/onboarding/formula': typeof OnboardingGuardedFormulaRoute
  '/onboarding/formula-config': typeof OnboardingGuardedFormulaConfigRoute
  '/onboarding/identity': typeof OnboardingGuardedIdentityRoute
  '/onboarding/legal': typeof OnboardingGuardedLegalRoute
  '/onboarding/phone': typeof OnboardingGuardedPhoneRoute
  '/onboarding/phone-verify': typeof OnboardingGuardedPhoneVerifyRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/driver/': typeof AuthenticatedDriverIndexRoute
  '/fleet/': typeof AuthenticatedFleetIndexRoute
  '/admin/bookings/$bookingId': typeof AuthenticatedAdminBookingsBookingIdRoute
  '/admin/clients/$clientId': typeof AuthenticatedAdminClientsClientIdRoute
  '/admin/drivers/$userId': typeof AuthenticatedAdminDriversUserIdRoute
  '/admin/rate-cards/$rateCardId': typeof AuthenticatedAdminRateCardsRateCardIdRoute
  '/admin/users/$remoteId': typeof AuthenticatedAdminUsersRemoteIdRoute
  '/admin/vehicle-groups/$vehicleGroupId': typeof AuthenticatedAdminVehicleGroupsVehicleGroupIdRoute
  '/admin/vehicles/$vehicleId': typeof AuthenticatedAdminVehiclesVehicleIdRoute
  '/admin/vehicles/active-usages': typeof AuthenticatedAdminVehiclesActiveUsagesRoute
  '/admin/vehicles/scheduler': typeof AuthenticatedAdminVehiclesSchedulerRoute
  '/admin/vehicles/suspended': typeof AuthenticatedAdminVehiclesSuspendedRoute
  '/fleet/drivers/$userId': typeof AuthenticatedFleetDriversUserIdRoute
  '/fleet/vehicles/$vehicleId': typeof AuthenticatedFleetVehiclesVehicleIdRoute
  '/admin/billing/': typeof AuthenticatedAdminBillingIndexRoute
  '/admin/bookings/': typeof AuthenticatedAdminBookingsIndexRoute
  '/admin/clients/': typeof AuthenticatedAdminClientsIndexRoute
  '/admin/damages/': typeof AuthenticatedAdminDamagesIndexRoute
  '/admin/drivers/': typeof AuthenticatedAdminDriversIndexRoute
  '/admin/rate-cards/': typeof AuthenticatedAdminRateCardsIndexRoute
  '/admin/tasks/': typeof AuthenticatedAdminTasksIndexRoute
  '/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
  '/admin/vehicle-groups/': typeof AuthenticatedAdminVehicleGroupsIndexRoute
  '/admin/vehicles/': typeof AuthenticatedAdminVehiclesIndexRoute
  '/fleet/billing/': typeof AuthenticatedFleetBillingIndexRoute
  '/fleet/drivers/': typeof AuthenticatedFleetDriversIndexRoute
  '/fleet/vehicles/': typeof AuthenticatedFleetVehiclesIndexRoute
  '/admin/charging/cards/$cardId': typeof AuthenticatedAdminChargingCardsCardIdRoute
  '/admin/charging/sessions/$sessionId': typeof AuthenticatedAdminChargingSessionsSessionIdRoute
  '/admin/tasks/cleaning/$cleaningId': typeof AuthenticatedAdminTasksCleaningCleaningIdRoute
  '/fleet/charging/cards/$cardId': typeof AuthenticatedFleetChargingCardsCardIdRoute
  '/admin/charging/cards/': typeof AuthenticatedAdminChargingCardsIndexRoute
  '/admin/charging/sessions/': typeof AuthenticatedAdminChargingSessionsIndexRoute
  '/admin/charging/stations/': typeof AuthenticatedAdminChargingStationsIndexRoute
  '/admin/tasks/cleaning/': typeof AuthenticatedAdminTasksCleaningIndexRoute
  '/admin/tasks/overdue/': typeof AuthenticatedAdminTasksOverdueIndexRoute
  '/admin/tasks/problematic-bookings/': typeof AuthenticatedAdminTasksProblematicBookingsIndexRoute
  '/fleet/charging/cards/': typeof AuthenticatedFleetChargingCardsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/onboarding/account': typeof OnboardingAccountRoute
  '/onboarding/email-verify': typeof OnboardingEmailVerifyRoute
  '/onboarding/start': typeof OnboardingStartRoute
  '/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/admin/system-status': typeof AuthenticatedAdminSystemStatusRoute
  '/admin/trips': typeof AuthenticatedAdminTripsRoute
  '/admin/vehicle-base-locations': typeof AuthenticatedAdminVehicleBaseLocationsRoute
  '/card-activation/$cardNumber': typeof AuthenticatedCardActivationCardNumberRoute
  '/driver/my-trips': typeof AuthenticatedDriverMyTripsRoute
  '/fleet/reports': typeof AuthenticatedFleetReportsRoute
  '/fleet/trips': typeof AuthenticatedFleetTripsRoute
  '/onboarding/address': typeof OnboardingGuardedAddressRoute
  '/onboarding/billing': typeof OnboardingGuardedBillingRoute
  '/onboarding/deposit': typeof OnboardingGuardedDepositRoute
  '/onboarding/drivers-license': typeof OnboardingGuardedDriversLicenseRoute
  '/onboarding/email-verified': typeof OnboardingGuardedEmailVerifiedRoute
  '/onboarding/final': typeof OnboardingGuardedFinalRoute
  '/onboarding/formula': typeof OnboardingGuardedFormulaRoute
  '/onboarding/formula-config': typeof OnboardingGuardedFormulaConfigRoute
  '/onboarding/identity': typeof OnboardingGuardedIdentityRoute
  '/onboarding/legal': typeof OnboardingGuardedLegalRoute
  '/onboarding/phone': typeof OnboardingGuardedPhoneRoute
  '/onboarding/phone-verify': typeof OnboardingGuardedPhoneVerifyRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/driver': typeof AuthenticatedDriverIndexRoute
  '/fleet': typeof AuthenticatedFleetIndexRoute
  '/admin/bookings/$bookingId': typeof AuthenticatedAdminBookingsBookingIdRoute
  '/admin/clients/$clientId': typeof AuthenticatedAdminClientsClientIdRoute
  '/admin/drivers/$userId': typeof AuthenticatedAdminDriversUserIdRoute
  '/admin/rate-cards/$rateCardId': typeof AuthenticatedAdminRateCardsRateCardIdRoute
  '/admin/users/$remoteId': typeof AuthenticatedAdminUsersRemoteIdRoute
  '/admin/vehicle-groups/$vehicleGroupId': typeof AuthenticatedAdminVehicleGroupsVehicleGroupIdRoute
  '/admin/vehicles/$vehicleId': typeof AuthenticatedAdminVehiclesVehicleIdRoute
  '/admin/vehicles/active-usages': typeof AuthenticatedAdminVehiclesActiveUsagesRoute
  '/admin/vehicles/scheduler': typeof AuthenticatedAdminVehiclesSchedulerRoute
  '/admin/vehicles/suspended': typeof AuthenticatedAdminVehiclesSuspendedRoute
  '/fleet/drivers/$userId': typeof AuthenticatedFleetDriversUserIdRoute
  '/fleet/vehicles/$vehicleId': typeof AuthenticatedFleetVehiclesVehicleIdRoute
  '/admin/billing': typeof AuthenticatedAdminBillingIndexRoute
  '/admin/bookings': typeof AuthenticatedAdminBookingsIndexRoute
  '/admin/clients': typeof AuthenticatedAdminClientsIndexRoute
  '/admin/damages': typeof AuthenticatedAdminDamagesIndexRoute
  '/admin/drivers': typeof AuthenticatedAdminDriversIndexRoute
  '/admin/rate-cards': typeof AuthenticatedAdminRateCardsIndexRoute
  '/admin/tasks': typeof AuthenticatedAdminTasksIndexRoute
  '/admin/users': typeof AuthenticatedAdminUsersIndexRoute
  '/admin/vehicle-groups': typeof AuthenticatedAdminVehicleGroupsIndexRoute
  '/admin/vehicles': typeof AuthenticatedAdminVehiclesIndexRoute
  '/fleet/billing': typeof AuthenticatedFleetBillingIndexRoute
  '/fleet/drivers': typeof AuthenticatedFleetDriversIndexRoute
  '/fleet/vehicles': typeof AuthenticatedFleetVehiclesIndexRoute
  '/admin/charging/cards/$cardId': typeof AuthenticatedAdminChargingCardsCardIdRoute
  '/admin/charging/sessions/$sessionId': typeof AuthenticatedAdminChargingSessionsSessionIdRoute
  '/admin/tasks/cleaning/$cleaningId': typeof AuthenticatedAdminTasksCleaningCleaningIdRoute
  '/fleet/charging/cards/$cardId': typeof AuthenticatedFleetChargingCardsCardIdRoute
  '/admin/charging/cards': typeof AuthenticatedAdminChargingCardsIndexRoute
  '/admin/charging/sessions': typeof AuthenticatedAdminChargingSessionsIndexRoute
  '/admin/charging/stations': typeof AuthenticatedAdminChargingStationsIndexRoute
  '/admin/tasks/cleaning': typeof AuthenticatedAdminTasksCleaningIndexRoute
  '/admin/tasks/overdue': typeof AuthenticatedAdminTasksOverdueIndexRoute
  '/admin/tasks/problematic-bookings': typeof AuthenticatedAdminTasksProblematicBookingsIndexRoute
  '/fleet/charging/cards': typeof AuthenticatedFleetChargingCardsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/driver': typeof AuthenticatedDriverRouteWithChildren
  '/_authenticated/fleet': typeof AuthenticatedFleetRouteWithChildren
  '/onboarding/_guarded': typeof OnboardingGuardedRouteWithChildren
  '/onboarding/account': typeof OnboardingAccountRoute
  '/onboarding/email-verify': typeof OnboardingEmailVerifyRoute
  '/onboarding/start': typeof OnboardingStartRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/_authenticated/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/_authenticated/admin/system-status': typeof AuthenticatedAdminSystemStatusRoute
  '/_authenticated/admin/trips': typeof AuthenticatedAdminTripsRoute
  '/_authenticated/admin/vehicle-base-locations': typeof AuthenticatedAdminVehicleBaseLocationsRoute
  '/_authenticated/card-activation/$cardNumber': typeof AuthenticatedCardActivationCardNumberRoute
  '/_authenticated/driver/my-trips': typeof AuthenticatedDriverMyTripsRoute
  '/_authenticated/fleet/reports': typeof AuthenticatedFleetReportsRoute
  '/_authenticated/fleet/trips': typeof AuthenticatedFleetTripsRoute
  '/onboarding/_guarded/address': typeof OnboardingGuardedAddressRoute
  '/onboarding/_guarded/billing': typeof OnboardingGuardedBillingRoute
  '/onboarding/_guarded/deposit': typeof OnboardingGuardedDepositRoute
  '/onboarding/_guarded/drivers-license': typeof OnboardingGuardedDriversLicenseRoute
  '/onboarding/_guarded/email-verified': typeof OnboardingGuardedEmailVerifiedRoute
  '/onboarding/_guarded/final': typeof OnboardingGuardedFinalRoute
  '/onboarding/_guarded/formula': typeof OnboardingGuardedFormulaRoute
  '/onboarding/_guarded/formula-config': typeof OnboardingGuardedFormulaConfigRoute
  '/onboarding/_guarded/identity': typeof OnboardingGuardedIdentityRoute
  '/onboarding/_guarded/legal': typeof OnboardingGuardedLegalRoute
  '/onboarding/_guarded/phone': typeof OnboardingGuardedPhoneRoute
  '/onboarding/_guarded/phone-verify': typeof OnboardingGuardedPhoneVerifyRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/driver/': typeof AuthenticatedDriverIndexRoute
  '/_authenticated/fleet/': typeof AuthenticatedFleetIndexRoute
  '/_authenticated/admin/bookings/$bookingId': typeof AuthenticatedAdminBookingsBookingIdRoute
  '/_authenticated/admin/clients/$clientId': typeof AuthenticatedAdminClientsClientIdRoute
  '/_authenticated/admin/drivers/$userId': typeof AuthenticatedAdminDriversUserIdRoute
  '/_authenticated/admin/rate-cards/$rateCardId': typeof AuthenticatedAdminRateCardsRateCardIdRoute
  '/_authenticated/admin/users/$remoteId': typeof AuthenticatedAdminUsersRemoteIdRoute
  '/_authenticated/admin/vehicle-groups/$vehicleGroupId': typeof AuthenticatedAdminVehicleGroupsVehicleGroupIdRoute
  '/_authenticated/admin/vehicles/$vehicleId': typeof AuthenticatedAdminVehiclesVehicleIdRoute
  '/_authenticated/admin/vehicles/active-usages': typeof AuthenticatedAdminVehiclesActiveUsagesRoute
  '/_authenticated/admin/vehicles/scheduler': typeof AuthenticatedAdminVehiclesSchedulerRoute
  '/_authenticated/admin/vehicles/suspended': typeof AuthenticatedAdminVehiclesSuspendedRoute
  '/_authenticated/fleet/drivers/$userId': typeof AuthenticatedFleetDriversUserIdRoute
  '/_authenticated/fleet/vehicles/$vehicleId': typeof AuthenticatedFleetVehiclesVehicleIdRoute
  '/_authenticated/admin/billing/': typeof AuthenticatedAdminBillingIndexRoute
  '/_authenticated/admin/bookings/': typeof AuthenticatedAdminBookingsIndexRoute
  '/_authenticated/admin/clients/': typeof AuthenticatedAdminClientsIndexRoute
  '/_authenticated/admin/damages/': typeof AuthenticatedAdminDamagesIndexRoute
  '/_authenticated/admin/drivers/': typeof AuthenticatedAdminDriversIndexRoute
  '/_authenticated/admin/rate-cards/': typeof AuthenticatedAdminRateCardsIndexRoute
  '/_authenticated/admin/tasks/': typeof AuthenticatedAdminTasksIndexRoute
  '/_authenticated/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
  '/_authenticated/admin/vehicle-groups/': typeof AuthenticatedAdminVehicleGroupsIndexRoute
  '/_authenticated/admin/vehicles/': typeof AuthenticatedAdminVehiclesIndexRoute
  '/_authenticated/fleet/billing/': typeof AuthenticatedFleetBillingIndexRoute
  '/_authenticated/fleet/drivers/': typeof AuthenticatedFleetDriversIndexRoute
  '/_authenticated/fleet/vehicles/': typeof AuthenticatedFleetVehiclesIndexRoute
  '/_authenticated/admin/charging/cards/$cardId': typeof AuthenticatedAdminChargingCardsCardIdRoute
  '/_authenticated/admin/charging/sessions/$sessionId': typeof AuthenticatedAdminChargingSessionsSessionIdRoute
  '/_authenticated/admin/tasks/cleaning/$cleaningId': typeof AuthenticatedAdminTasksCleaningCleaningIdRoute
  '/_authenticated/fleet/charging/cards/$cardId': typeof AuthenticatedFleetChargingCardsCardIdRoute
  '/_authenticated/admin/charging/cards/': typeof AuthenticatedAdminChargingCardsIndexRoute
  '/_authenticated/admin/charging/sessions/': typeof AuthenticatedAdminChargingSessionsIndexRoute
  '/_authenticated/admin/charging/stations/': typeof AuthenticatedAdminChargingStationsIndexRoute
  '/_authenticated/admin/tasks/cleaning/': typeof AuthenticatedAdminTasksCleaningIndexRoute
  '/_authenticated/admin/tasks/overdue/': typeof AuthenticatedAdminTasksOverdueIndexRoute
  '/_authenticated/admin/tasks/problematic-bookings/': typeof AuthenticatedAdminTasksProblematicBookingsIndexRoute
  '/_authenticated/fleet/charging/cards/': typeof AuthenticatedFleetChargingCardsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/onboarding'
    | '/unauthorized'
    | '/admin'
    | '/driver'
    | '/fleet'
    | '/onboarding/account'
    | '/onboarding/email-verify'
    | '/onboarding/start'
    | '/onboarding/'
    | '/admin/reports'
    | '/admin/system-status'
    | '/admin/trips'
    | '/admin/vehicle-base-locations'
    | '/card-activation/$cardNumber'
    | '/driver/my-trips'
    | '/fleet/reports'
    | '/fleet/trips'
    | '/onboarding/address'
    | '/onboarding/billing'
    | '/onboarding/deposit'
    | '/onboarding/drivers-license'
    | '/onboarding/email-verified'
    | '/onboarding/final'
    | '/onboarding/formula'
    | '/onboarding/formula-config'
    | '/onboarding/identity'
    | '/onboarding/legal'
    | '/onboarding/phone'
    | '/onboarding/phone-verify'
    | '/admin/'
    | '/driver/'
    | '/fleet/'
    | '/admin/bookings/$bookingId'
    | '/admin/clients/$clientId'
    | '/admin/drivers/$userId'
    | '/admin/rate-cards/$rateCardId'
    | '/admin/users/$remoteId'
    | '/admin/vehicle-groups/$vehicleGroupId'
    | '/admin/vehicles/$vehicleId'
    | '/admin/vehicles/active-usages'
    | '/admin/vehicles/scheduler'
    | '/admin/vehicles/suspended'
    | '/fleet/drivers/$userId'
    | '/fleet/vehicles/$vehicleId'
    | '/admin/billing/'
    | '/admin/bookings/'
    | '/admin/clients/'
    | '/admin/damages/'
    | '/admin/drivers/'
    | '/admin/rate-cards/'
    | '/admin/tasks/'
    | '/admin/users/'
    | '/admin/vehicle-groups/'
    | '/admin/vehicles/'
    | '/fleet/billing/'
    | '/fleet/drivers/'
    | '/fleet/vehicles/'
    | '/admin/charging/cards/$cardId'
    | '/admin/charging/sessions/$sessionId'
    | '/admin/tasks/cleaning/$cleaningId'
    | '/fleet/charging/cards/$cardId'
    | '/admin/charging/cards/'
    | '/admin/charging/sessions/'
    | '/admin/charging/stations/'
    | '/admin/tasks/cleaning/'
    | '/admin/tasks/overdue/'
    | '/admin/tasks/problematic-bookings/'
    | '/fleet/charging/cards/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/unauthorized'
    | '/onboarding'
    | '/onboarding/account'
    | '/onboarding/email-verify'
    | '/onboarding/start'
    | '/admin/reports'
    | '/admin/system-status'
    | '/admin/trips'
    | '/admin/vehicle-base-locations'
    | '/card-activation/$cardNumber'
    | '/driver/my-trips'
    | '/fleet/reports'
    | '/fleet/trips'
    | '/onboarding/address'
    | '/onboarding/billing'
    | '/onboarding/deposit'
    | '/onboarding/drivers-license'
    | '/onboarding/email-verified'
    | '/onboarding/final'
    | '/onboarding/formula'
    | '/onboarding/formula-config'
    | '/onboarding/identity'
    | '/onboarding/legal'
    | '/onboarding/phone'
    | '/onboarding/phone-verify'
    | '/admin'
    | '/driver'
    | '/fleet'
    | '/admin/bookings/$bookingId'
    | '/admin/clients/$clientId'
    | '/admin/drivers/$userId'
    | '/admin/rate-cards/$rateCardId'
    | '/admin/users/$remoteId'
    | '/admin/vehicle-groups/$vehicleGroupId'
    | '/admin/vehicles/$vehicleId'
    | '/admin/vehicles/active-usages'
    | '/admin/vehicles/scheduler'
    | '/admin/vehicles/suspended'
    | '/fleet/drivers/$userId'
    | '/fleet/vehicles/$vehicleId'
    | '/admin/billing'
    | '/admin/bookings'
    | '/admin/clients'
    | '/admin/damages'
    | '/admin/drivers'
    | '/admin/rate-cards'
    | '/admin/tasks'
    | '/admin/users'
    | '/admin/vehicle-groups'
    | '/admin/vehicles'
    | '/fleet/billing'
    | '/fleet/drivers'
    | '/fleet/vehicles'
    | '/admin/charging/cards/$cardId'
    | '/admin/charging/sessions/$sessionId'
    | '/admin/tasks/cleaning/$cleaningId'
    | '/fleet/charging/cards/$cardId'
    | '/admin/charging/cards'
    | '/admin/charging/sessions'
    | '/admin/charging/stations'
    | '/admin/tasks/cleaning'
    | '/admin/tasks/overdue'
    | '/admin/tasks/problematic-bookings'
    | '/fleet/charging/cards'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/onboarding'
    | '/unauthorized'
    | '/_authenticated/admin'
    | '/_authenticated/driver'
    | '/_authenticated/fleet'
    | '/onboarding/_guarded'
    | '/onboarding/account'
    | '/onboarding/email-verify'
    | '/onboarding/start'
    | '/onboarding/'
    | '/_authenticated/admin/reports'
    | '/_authenticated/admin/system-status'
    | '/_authenticated/admin/trips'
    | '/_authenticated/admin/vehicle-base-locations'
    | '/_authenticated/card-activation/$cardNumber'
    | '/_authenticated/driver/my-trips'
    | '/_authenticated/fleet/reports'
    | '/_authenticated/fleet/trips'
    | '/onboarding/_guarded/address'
    | '/onboarding/_guarded/billing'
    | '/onboarding/_guarded/deposit'
    | '/onboarding/_guarded/drivers-license'
    | '/onboarding/_guarded/email-verified'
    | '/onboarding/_guarded/final'
    | '/onboarding/_guarded/formula'
    | '/onboarding/_guarded/formula-config'
    | '/onboarding/_guarded/identity'
    | '/onboarding/_guarded/legal'
    | '/onboarding/_guarded/phone'
    | '/onboarding/_guarded/phone-verify'
    | '/_authenticated/admin/'
    | '/_authenticated/driver/'
    | '/_authenticated/fleet/'
    | '/_authenticated/admin/bookings/$bookingId'
    | '/_authenticated/admin/clients/$clientId'
    | '/_authenticated/admin/drivers/$userId'
    | '/_authenticated/admin/rate-cards/$rateCardId'
    | '/_authenticated/admin/users/$remoteId'
    | '/_authenticated/admin/vehicle-groups/$vehicleGroupId'
    | '/_authenticated/admin/vehicles/$vehicleId'
    | '/_authenticated/admin/vehicles/active-usages'
    | '/_authenticated/admin/vehicles/scheduler'
    | '/_authenticated/admin/vehicles/suspended'
    | '/_authenticated/fleet/drivers/$userId'
    | '/_authenticated/fleet/vehicles/$vehicleId'
    | '/_authenticated/admin/billing/'
    | '/_authenticated/admin/bookings/'
    | '/_authenticated/admin/clients/'
    | '/_authenticated/admin/damages/'
    | '/_authenticated/admin/drivers/'
    | '/_authenticated/admin/rate-cards/'
    | '/_authenticated/admin/tasks/'
    | '/_authenticated/admin/users/'
    | '/_authenticated/admin/vehicle-groups/'
    | '/_authenticated/admin/vehicles/'
    | '/_authenticated/fleet/billing/'
    | '/_authenticated/fleet/drivers/'
    | '/_authenticated/fleet/vehicles/'
    | '/_authenticated/admin/charging/cards/$cardId'
    | '/_authenticated/admin/charging/sessions/$sessionId'
    | '/_authenticated/admin/tasks/cleaning/$cleaningId'
    | '/_authenticated/fleet/charging/cards/$cardId'
    | '/_authenticated/admin/charging/cards/'
    | '/_authenticated/admin/charging/sessions/'
    | '/_authenticated/admin/charging/stations/'
    | '/_authenticated/admin/tasks/cleaning/'
    | '/_authenticated/admin/tasks/overdue/'
    | '/_authenticated/admin/tasks/problematic-bookings/'
    | '/_authenticated/fleet/charging/cards/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/start': {
      id: '/onboarding/start'
      path: '/start'
      fullPath: '/onboarding/start'
      preLoaderRoute: typeof OnboardingStartRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/email-verify': {
      id: '/onboarding/email-verify'
      path: '/email-verify'
      fullPath: '/onboarding/email-verify'
      preLoaderRoute: typeof OnboardingEmailVerifyRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/account': {
      id: '/onboarding/account'
      path: '/account'
      fullPath: '/onboarding/account'
      preLoaderRoute: typeof OnboardingAccountRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/_guarded': {
      id: '/onboarding/_guarded'
      path: ''
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingGuardedRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/_authenticated/fleet': {
      id: '/_authenticated/fleet'
      path: '/fleet'
      fullPath: '/fleet'
      preLoaderRoute: typeof AuthenticatedFleetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/driver': {
      id: '/_authenticated/driver'
      path: '/driver'
      fullPath: '/driver'
      preLoaderRoute: typeof AuthenticatedDriverRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleet/': {
      id: '/_authenticated/fleet/'
      path: '/'
      fullPath: '/fleet/'
      preLoaderRoute: typeof AuthenticatedFleetIndexRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/driver/': {
      id: '/_authenticated/driver/'
      path: '/'
      fullPath: '/driver/'
      preLoaderRoute: typeof AuthenticatedDriverIndexRouteImport
      parentRoute: typeof AuthenticatedDriverRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/onboarding/_guarded/phone-verify': {
      id: '/onboarding/_guarded/phone-verify'
      path: '/phone-verify'
      fullPath: '/onboarding/phone-verify'
      preLoaderRoute: typeof OnboardingGuardedPhoneVerifyRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/phone': {
      id: '/onboarding/_guarded/phone'
      path: '/phone'
      fullPath: '/onboarding/phone'
      preLoaderRoute: typeof OnboardingGuardedPhoneRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/legal': {
      id: '/onboarding/_guarded/legal'
      path: '/legal'
      fullPath: '/onboarding/legal'
      preLoaderRoute: typeof OnboardingGuardedLegalRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/identity': {
      id: '/onboarding/_guarded/identity'
      path: '/identity'
      fullPath: '/onboarding/identity'
      preLoaderRoute: typeof OnboardingGuardedIdentityRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/formula-config': {
      id: '/onboarding/_guarded/formula-config'
      path: '/formula-config'
      fullPath: '/onboarding/formula-config'
      preLoaderRoute: typeof OnboardingGuardedFormulaConfigRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/formula': {
      id: '/onboarding/_guarded/formula'
      path: '/formula'
      fullPath: '/onboarding/formula'
      preLoaderRoute: typeof OnboardingGuardedFormulaRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/final': {
      id: '/onboarding/_guarded/final'
      path: '/final'
      fullPath: '/onboarding/final'
      preLoaderRoute: typeof OnboardingGuardedFinalRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/email-verified': {
      id: '/onboarding/_guarded/email-verified'
      path: '/email-verified'
      fullPath: '/onboarding/email-verified'
      preLoaderRoute: typeof OnboardingGuardedEmailVerifiedRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/drivers-license': {
      id: '/onboarding/_guarded/drivers-license'
      path: '/drivers-license'
      fullPath: '/onboarding/drivers-license'
      preLoaderRoute: typeof OnboardingGuardedDriversLicenseRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/deposit': {
      id: '/onboarding/_guarded/deposit'
      path: '/deposit'
      fullPath: '/onboarding/deposit'
      preLoaderRoute: typeof OnboardingGuardedDepositRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/billing': {
      id: '/onboarding/_guarded/billing'
      path: '/billing'
      fullPath: '/onboarding/billing'
      preLoaderRoute: typeof OnboardingGuardedBillingRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/onboarding/_guarded/address': {
      id: '/onboarding/_guarded/address'
      path: '/address'
      fullPath: '/onboarding/address'
      preLoaderRoute: typeof OnboardingGuardedAddressRouteImport
      parentRoute: typeof OnboardingGuardedRoute
    }
    '/_authenticated/fleet/trips': {
      id: '/_authenticated/fleet/trips'
      path: '/trips'
      fullPath: '/fleet/trips'
      preLoaderRoute: typeof AuthenticatedFleetTripsRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/fleet/reports': {
      id: '/_authenticated/fleet/reports'
      path: '/reports'
      fullPath: '/fleet/reports'
      preLoaderRoute: typeof AuthenticatedFleetReportsRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/driver/my-trips': {
      id: '/_authenticated/driver/my-trips'
      path: '/my-trips'
      fullPath: '/driver/my-trips'
      preLoaderRoute: typeof AuthenticatedDriverMyTripsRouteImport
      parentRoute: typeof AuthenticatedDriverRoute
    }
    '/_authenticated/card-activation/$cardNumber': {
      id: '/_authenticated/card-activation/$cardNumber'
      path: '/card-activation/$cardNumber'
      fullPath: '/card-activation/$cardNumber'
      preLoaderRoute: typeof AuthenticatedCardActivationCardNumberRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/vehicle-base-locations': {
      id: '/_authenticated/admin/vehicle-base-locations'
      path: '/vehicle-base-locations'
      fullPath: '/admin/vehicle-base-locations'
      preLoaderRoute: typeof AuthenticatedAdminVehicleBaseLocationsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/trips': {
      id: '/_authenticated/admin/trips'
      path: '/trips'
      fullPath: '/admin/trips'
      preLoaderRoute: typeof AuthenticatedAdminTripsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/system-status': {
      id: '/_authenticated/admin/system-status'
      path: '/system-status'
      fullPath: '/admin/system-status'
      preLoaderRoute: typeof AuthenticatedAdminSystemStatusRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/reports': {
      id: '/_authenticated/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AuthenticatedAdminReportsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/fleet/vehicles/': {
      id: '/_authenticated/fleet/vehicles/'
      path: '/vehicles'
      fullPath: '/fleet/vehicles/'
      preLoaderRoute: typeof AuthenticatedFleetVehiclesIndexRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/fleet/drivers/': {
      id: '/_authenticated/fleet/drivers/'
      path: '/drivers'
      fullPath: '/fleet/drivers/'
      preLoaderRoute: typeof AuthenticatedFleetDriversIndexRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/fleet/billing/': {
      id: '/_authenticated/fleet/billing/'
      path: '/billing'
      fullPath: '/fleet/billing/'
      preLoaderRoute: typeof AuthenticatedFleetBillingIndexRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/admin/vehicles/': {
      id: '/_authenticated/admin/vehicles/'
      path: '/vehicles'
      fullPath: '/admin/vehicles/'
      preLoaderRoute: typeof AuthenticatedAdminVehiclesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/vehicle-groups/': {
      id: '/_authenticated/admin/vehicle-groups/'
      path: '/vehicle-groups'
      fullPath: '/admin/vehicle-groups/'
      preLoaderRoute: typeof AuthenticatedAdminVehicleGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/users/': {
      id: '/_authenticated/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthenticatedAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/tasks/': {
      id: '/_authenticated/admin/tasks/'
      path: '/tasks'
      fullPath: '/admin/tasks/'
      preLoaderRoute: typeof AuthenticatedAdminTasksIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/rate-cards/': {
      id: '/_authenticated/admin/rate-cards/'
      path: '/rate-cards'
      fullPath: '/admin/rate-cards/'
      preLoaderRoute: typeof AuthenticatedAdminRateCardsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/drivers/': {
      id: '/_authenticated/admin/drivers/'
      path: '/drivers'
      fullPath: '/admin/drivers/'
      preLoaderRoute: typeof AuthenticatedAdminDriversIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/damages/': {
      id: '/_authenticated/admin/damages/'
      path: '/damages'
      fullPath: '/admin/damages/'
      preLoaderRoute: typeof AuthenticatedAdminDamagesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/clients/': {
      id: '/_authenticated/admin/clients/'
      path: '/clients'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AuthenticatedAdminClientsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/bookings/': {
      id: '/_authenticated/admin/bookings/'
      path: '/bookings'
      fullPath: '/admin/bookings/'
      preLoaderRoute: typeof AuthenticatedAdminBookingsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/billing/': {
      id: '/_authenticated/admin/billing/'
      path: '/billing'
      fullPath: '/admin/billing/'
      preLoaderRoute: typeof AuthenticatedAdminBillingIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/fleet/vehicles/$vehicleId': {
      id: '/_authenticated/fleet/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/fleet/vehicles/$vehicleId'
      preLoaderRoute: typeof AuthenticatedFleetVehiclesVehicleIdRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/fleet/drivers/$userId': {
      id: '/_authenticated/fleet/drivers/$userId'
      path: '/drivers/$userId'
      fullPath: '/fleet/drivers/$userId'
      preLoaderRoute: typeof AuthenticatedFleetDriversUserIdRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/admin/vehicles/suspended': {
      id: '/_authenticated/admin/vehicles/suspended'
      path: '/vehicles/suspended'
      fullPath: '/admin/vehicles/suspended'
      preLoaderRoute: typeof AuthenticatedAdminVehiclesSuspendedRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/vehicles/scheduler': {
      id: '/_authenticated/admin/vehicles/scheduler'
      path: '/vehicles/scheduler'
      fullPath: '/admin/vehicles/scheduler'
      preLoaderRoute: typeof AuthenticatedAdminVehiclesSchedulerRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/vehicles/active-usages': {
      id: '/_authenticated/admin/vehicles/active-usages'
      path: '/vehicles/active-usages'
      fullPath: '/admin/vehicles/active-usages'
      preLoaderRoute: typeof AuthenticatedAdminVehiclesActiveUsagesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/vehicles/$vehicleId': {
      id: '/_authenticated/admin/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/admin/vehicles/$vehicleId'
      preLoaderRoute: typeof AuthenticatedAdminVehiclesVehicleIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/vehicle-groups/$vehicleGroupId': {
      id: '/_authenticated/admin/vehicle-groups/$vehicleGroupId'
      path: '/vehicle-groups/$vehicleGroupId'
      fullPath: '/admin/vehicle-groups/$vehicleGroupId'
      preLoaderRoute: typeof AuthenticatedAdminVehicleGroupsVehicleGroupIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/users/$remoteId': {
      id: '/_authenticated/admin/users/$remoteId'
      path: '/users/$remoteId'
      fullPath: '/admin/users/$remoteId'
      preLoaderRoute: typeof AuthenticatedAdminUsersRemoteIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/rate-cards/$rateCardId': {
      id: '/_authenticated/admin/rate-cards/$rateCardId'
      path: '/rate-cards/$rateCardId'
      fullPath: '/admin/rate-cards/$rateCardId'
      preLoaderRoute: typeof AuthenticatedAdminRateCardsRateCardIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/drivers/$userId': {
      id: '/_authenticated/admin/drivers/$userId'
      path: '/drivers/$userId'
      fullPath: '/admin/drivers/$userId'
      preLoaderRoute: typeof AuthenticatedAdminDriversUserIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/clients/$clientId': {
      id: '/_authenticated/admin/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/admin/clients/$clientId'
      preLoaderRoute: typeof AuthenticatedAdminClientsClientIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/bookings/$bookingId': {
      id: '/_authenticated/admin/bookings/$bookingId'
      path: '/bookings/$bookingId'
      fullPath: '/admin/bookings/$bookingId'
      preLoaderRoute: typeof AuthenticatedAdminBookingsBookingIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/fleet/charging/cards/': {
      id: '/_authenticated/fleet/charging/cards/'
      path: '/charging/cards'
      fullPath: '/fleet/charging/cards/'
      preLoaderRoute: typeof AuthenticatedFleetChargingCardsIndexRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/admin/tasks/problematic-bookings/': {
      id: '/_authenticated/admin/tasks/problematic-bookings/'
      path: '/tasks/problematic-bookings'
      fullPath: '/admin/tasks/problematic-bookings/'
      preLoaderRoute: typeof AuthenticatedAdminTasksProblematicBookingsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/tasks/overdue/': {
      id: '/_authenticated/admin/tasks/overdue/'
      path: '/tasks/overdue'
      fullPath: '/admin/tasks/overdue/'
      preLoaderRoute: typeof AuthenticatedAdminTasksOverdueIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/tasks/cleaning/': {
      id: '/_authenticated/admin/tasks/cleaning/'
      path: '/tasks/cleaning'
      fullPath: '/admin/tasks/cleaning/'
      preLoaderRoute: typeof AuthenticatedAdminTasksCleaningIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/charging/stations/': {
      id: '/_authenticated/admin/charging/stations/'
      path: '/charging/stations'
      fullPath: '/admin/charging/stations/'
      preLoaderRoute: typeof AuthenticatedAdminChargingStationsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/charging/sessions/': {
      id: '/_authenticated/admin/charging/sessions/'
      path: '/charging/sessions'
      fullPath: '/admin/charging/sessions/'
      preLoaderRoute: typeof AuthenticatedAdminChargingSessionsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/charging/cards/': {
      id: '/_authenticated/admin/charging/cards/'
      path: '/charging/cards'
      fullPath: '/admin/charging/cards/'
      preLoaderRoute: typeof AuthenticatedAdminChargingCardsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/fleet/charging/cards/$cardId': {
      id: '/_authenticated/fleet/charging/cards/$cardId'
      path: '/charging/cards/$cardId'
      fullPath: '/fleet/charging/cards/$cardId'
      preLoaderRoute: typeof AuthenticatedFleetChargingCardsCardIdRouteImport
      parentRoute: typeof AuthenticatedFleetRoute
    }
    '/_authenticated/admin/tasks/cleaning/$cleaningId': {
      id: '/_authenticated/admin/tasks/cleaning/$cleaningId'
      path: '/tasks/cleaning/$cleaningId'
      fullPath: '/admin/tasks/cleaning/$cleaningId'
      preLoaderRoute: typeof AuthenticatedAdminTasksCleaningCleaningIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/charging/sessions/$sessionId': {
      id: '/_authenticated/admin/charging/sessions/$sessionId'
      path: '/charging/sessions/$sessionId'
      fullPath: '/admin/charging/sessions/$sessionId'
      preLoaderRoute: typeof AuthenticatedAdminChargingSessionsSessionIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/charging/cards/$cardId': {
      id: '/_authenticated/admin/charging/cards/$cardId'
      path: '/charging/cards/$cardId'
      fullPath: '/admin/charging/cards/$cardId'
      preLoaderRoute: typeof AuthenticatedAdminChargingCardsCardIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminReportsRoute: typeof AuthenticatedAdminReportsRoute
  AuthenticatedAdminSystemStatusRoute: typeof AuthenticatedAdminSystemStatusRoute
  AuthenticatedAdminTripsRoute: typeof AuthenticatedAdminTripsRoute
  AuthenticatedAdminVehicleBaseLocationsRoute: typeof AuthenticatedAdminVehicleBaseLocationsRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminBookingsBookingIdRoute: typeof AuthenticatedAdminBookingsBookingIdRoute
  AuthenticatedAdminClientsClientIdRoute: typeof AuthenticatedAdminClientsClientIdRoute
  AuthenticatedAdminDriversUserIdRoute: typeof AuthenticatedAdminDriversUserIdRoute
  AuthenticatedAdminRateCardsRateCardIdRoute: typeof AuthenticatedAdminRateCardsRateCardIdRoute
  AuthenticatedAdminUsersRemoteIdRoute: typeof AuthenticatedAdminUsersRemoteIdRoute
  AuthenticatedAdminVehicleGroupsVehicleGroupIdRoute: typeof AuthenticatedAdminVehicleGroupsVehicleGroupIdRoute
  AuthenticatedAdminVehiclesVehicleIdRoute: typeof AuthenticatedAdminVehiclesVehicleIdRoute
  AuthenticatedAdminVehiclesActiveUsagesRoute: typeof AuthenticatedAdminVehiclesActiveUsagesRoute
  AuthenticatedAdminVehiclesSchedulerRoute: typeof AuthenticatedAdminVehiclesSchedulerRoute
  AuthenticatedAdminVehiclesSuspendedRoute: typeof AuthenticatedAdminVehiclesSuspendedRoute
  AuthenticatedAdminBillingIndexRoute: typeof AuthenticatedAdminBillingIndexRoute
  AuthenticatedAdminBookingsIndexRoute: typeof AuthenticatedAdminBookingsIndexRoute
  AuthenticatedAdminClientsIndexRoute: typeof AuthenticatedAdminClientsIndexRoute
  AuthenticatedAdminDamagesIndexRoute: typeof AuthenticatedAdminDamagesIndexRoute
  AuthenticatedAdminDriversIndexRoute: typeof AuthenticatedAdminDriversIndexRoute
  AuthenticatedAdminRateCardsIndexRoute: typeof AuthenticatedAdminRateCardsIndexRoute
  AuthenticatedAdminTasksIndexRoute: typeof AuthenticatedAdminTasksIndexRoute
  AuthenticatedAdminUsersIndexRoute: typeof AuthenticatedAdminUsersIndexRoute
  AuthenticatedAdminVehicleGroupsIndexRoute: typeof AuthenticatedAdminVehicleGroupsIndexRoute
  AuthenticatedAdminVehiclesIndexRoute: typeof AuthenticatedAdminVehiclesIndexRoute
  AuthenticatedAdminChargingCardsCardIdRoute: typeof AuthenticatedAdminChargingCardsCardIdRoute
  AuthenticatedAdminChargingSessionsSessionIdRoute: typeof AuthenticatedAdminChargingSessionsSessionIdRoute
  AuthenticatedAdminTasksCleaningCleaningIdRoute: typeof AuthenticatedAdminTasksCleaningCleaningIdRoute
  AuthenticatedAdminChargingCardsIndexRoute: typeof AuthenticatedAdminChargingCardsIndexRoute
  AuthenticatedAdminChargingSessionsIndexRoute: typeof AuthenticatedAdminChargingSessionsIndexRoute
  AuthenticatedAdminChargingStationsIndexRoute: typeof AuthenticatedAdminChargingStationsIndexRoute
  AuthenticatedAdminTasksCleaningIndexRoute: typeof AuthenticatedAdminTasksCleaningIndexRoute
  AuthenticatedAdminTasksOverdueIndexRoute: typeof AuthenticatedAdminTasksOverdueIndexRoute
  AuthenticatedAdminTasksProblematicBookingsIndexRoute: typeof AuthenticatedAdminTasksProblematicBookingsIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminReportsRoute: AuthenticatedAdminReportsRoute,
  AuthenticatedAdminSystemStatusRoute: AuthenticatedAdminSystemStatusRoute,
  AuthenticatedAdminTripsRoute: AuthenticatedAdminTripsRoute,
  AuthenticatedAdminVehicleBaseLocationsRoute:
    AuthenticatedAdminVehicleBaseLocationsRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminBookingsBookingIdRoute:
    AuthenticatedAdminBookingsBookingIdRoute,
  AuthenticatedAdminClientsClientIdRoute:
    AuthenticatedAdminClientsClientIdRoute,
  AuthenticatedAdminDriversUserIdRoute: AuthenticatedAdminDriversUserIdRoute,
  AuthenticatedAdminRateCardsRateCardIdRoute:
    AuthenticatedAdminRateCardsRateCardIdRoute,
  AuthenticatedAdminUsersRemoteIdRoute: AuthenticatedAdminUsersRemoteIdRoute,
  AuthenticatedAdminVehicleGroupsVehicleGroupIdRoute:
    AuthenticatedAdminVehicleGroupsVehicleGroupIdRoute,
  AuthenticatedAdminVehiclesVehicleIdRoute:
    AuthenticatedAdminVehiclesVehicleIdRoute,
  AuthenticatedAdminVehiclesActiveUsagesRoute:
    AuthenticatedAdminVehiclesActiveUsagesRoute,
  AuthenticatedAdminVehiclesSchedulerRoute:
    AuthenticatedAdminVehiclesSchedulerRoute,
  AuthenticatedAdminVehiclesSuspendedRoute:
    AuthenticatedAdminVehiclesSuspendedRoute,
  AuthenticatedAdminBillingIndexRoute: AuthenticatedAdminBillingIndexRoute,
  AuthenticatedAdminBookingsIndexRoute: AuthenticatedAdminBookingsIndexRoute,
  AuthenticatedAdminClientsIndexRoute: AuthenticatedAdminClientsIndexRoute,
  AuthenticatedAdminDamagesIndexRoute: AuthenticatedAdminDamagesIndexRoute,
  AuthenticatedAdminDriversIndexRoute: AuthenticatedAdminDriversIndexRoute,
  AuthenticatedAdminRateCardsIndexRoute: AuthenticatedAdminRateCardsIndexRoute,
  AuthenticatedAdminTasksIndexRoute: AuthenticatedAdminTasksIndexRoute,
  AuthenticatedAdminUsersIndexRoute: AuthenticatedAdminUsersIndexRoute,
  AuthenticatedAdminVehicleGroupsIndexRoute:
    AuthenticatedAdminVehicleGroupsIndexRoute,
  AuthenticatedAdminVehiclesIndexRoute: AuthenticatedAdminVehiclesIndexRoute,
  AuthenticatedAdminChargingCardsCardIdRoute:
    AuthenticatedAdminChargingCardsCardIdRoute,
  AuthenticatedAdminChargingSessionsSessionIdRoute:
    AuthenticatedAdminChargingSessionsSessionIdRoute,
  AuthenticatedAdminTasksCleaningCleaningIdRoute:
    AuthenticatedAdminTasksCleaningCleaningIdRoute,
  AuthenticatedAdminChargingCardsIndexRoute:
    AuthenticatedAdminChargingCardsIndexRoute,
  AuthenticatedAdminChargingSessionsIndexRoute:
    AuthenticatedAdminChargingSessionsIndexRoute,
  AuthenticatedAdminChargingStationsIndexRoute:
    AuthenticatedAdminChargingStationsIndexRoute,
  AuthenticatedAdminTasksCleaningIndexRoute:
    AuthenticatedAdminTasksCleaningIndexRoute,
  AuthenticatedAdminTasksOverdueIndexRoute:
    AuthenticatedAdminTasksOverdueIndexRoute,
  AuthenticatedAdminTasksProblematicBookingsIndexRoute:
    AuthenticatedAdminTasksProblematicBookingsIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedDriverRouteChildren {
  AuthenticatedDriverMyTripsRoute: typeof AuthenticatedDriverMyTripsRoute
  AuthenticatedDriverIndexRoute: typeof AuthenticatedDriverIndexRoute
}

const AuthenticatedDriverRouteChildren: AuthenticatedDriverRouteChildren = {
  AuthenticatedDriverMyTripsRoute: AuthenticatedDriverMyTripsRoute,
  AuthenticatedDriverIndexRoute: AuthenticatedDriverIndexRoute,
}

const AuthenticatedDriverRouteWithChildren =
  AuthenticatedDriverRoute._addFileChildren(AuthenticatedDriverRouteChildren)

interface AuthenticatedFleetRouteChildren {
  AuthenticatedFleetReportsRoute: typeof AuthenticatedFleetReportsRoute
  AuthenticatedFleetTripsRoute: typeof AuthenticatedFleetTripsRoute
  AuthenticatedFleetIndexRoute: typeof AuthenticatedFleetIndexRoute
  AuthenticatedFleetDriversUserIdRoute: typeof AuthenticatedFleetDriversUserIdRoute
  AuthenticatedFleetVehiclesVehicleIdRoute: typeof AuthenticatedFleetVehiclesVehicleIdRoute
  AuthenticatedFleetBillingIndexRoute: typeof AuthenticatedFleetBillingIndexRoute
  AuthenticatedFleetDriversIndexRoute: typeof AuthenticatedFleetDriversIndexRoute
  AuthenticatedFleetVehiclesIndexRoute: typeof AuthenticatedFleetVehiclesIndexRoute
  AuthenticatedFleetChargingCardsCardIdRoute: typeof AuthenticatedFleetChargingCardsCardIdRoute
  AuthenticatedFleetChargingCardsIndexRoute: typeof AuthenticatedFleetChargingCardsIndexRoute
}

const AuthenticatedFleetRouteChildren: AuthenticatedFleetRouteChildren = {
  AuthenticatedFleetReportsRoute: AuthenticatedFleetReportsRoute,
  AuthenticatedFleetTripsRoute: AuthenticatedFleetTripsRoute,
  AuthenticatedFleetIndexRoute: AuthenticatedFleetIndexRoute,
  AuthenticatedFleetDriversUserIdRoute: AuthenticatedFleetDriversUserIdRoute,
  AuthenticatedFleetVehiclesVehicleIdRoute:
    AuthenticatedFleetVehiclesVehicleIdRoute,
  AuthenticatedFleetBillingIndexRoute: AuthenticatedFleetBillingIndexRoute,
  AuthenticatedFleetDriversIndexRoute: AuthenticatedFleetDriversIndexRoute,
  AuthenticatedFleetVehiclesIndexRoute: AuthenticatedFleetVehiclesIndexRoute,
  AuthenticatedFleetChargingCardsCardIdRoute:
    AuthenticatedFleetChargingCardsCardIdRoute,
  AuthenticatedFleetChargingCardsIndexRoute:
    AuthenticatedFleetChargingCardsIndexRoute,
}

const AuthenticatedFleetRouteWithChildren =
  AuthenticatedFleetRoute._addFileChildren(AuthenticatedFleetRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedDriverRoute: typeof AuthenticatedDriverRouteWithChildren
  AuthenticatedFleetRoute: typeof AuthenticatedFleetRouteWithChildren
  AuthenticatedCardActivationCardNumberRoute: typeof AuthenticatedCardActivationCardNumberRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedDriverRoute: AuthenticatedDriverRouteWithChildren,
  AuthenticatedFleetRoute: AuthenticatedFleetRouteWithChildren,
  AuthenticatedCardActivationCardNumberRoute:
    AuthenticatedCardActivationCardNumberRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface OnboardingGuardedRouteChildren {
  OnboardingGuardedAddressRoute: typeof OnboardingGuardedAddressRoute
  OnboardingGuardedBillingRoute: typeof OnboardingGuardedBillingRoute
  OnboardingGuardedDepositRoute: typeof OnboardingGuardedDepositRoute
  OnboardingGuardedDriversLicenseRoute: typeof OnboardingGuardedDriversLicenseRoute
  OnboardingGuardedEmailVerifiedRoute: typeof OnboardingGuardedEmailVerifiedRoute
  OnboardingGuardedFinalRoute: typeof OnboardingGuardedFinalRoute
  OnboardingGuardedFormulaRoute: typeof OnboardingGuardedFormulaRoute
  OnboardingGuardedFormulaConfigRoute: typeof OnboardingGuardedFormulaConfigRoute
  OnboardingGuardedIdentityRoute: typeof OnboardingGuardedIdentityRoute
  OnboardingGuardedLegalRoute: typeof OnboardingGuardedLegalRoute
  OnboardingGuardedPhoneRoute: typeof OnboardingGuardedPhoneRoute
  OnboardingGuardedPhoneVerifyRoute: typeof OnboardingGuardedPhoneVerifyRoute
}

const OnboardingGuardedRouteChildren: OnboardingGuardedRouteChildren = {
  OnboardingGuardedAddressRoute: OnboardingGuardedAddressRoute,
  OnboardingGuardedBillingRoute: OnboardingGuardedBillingRoute,
  OnboardingGuardedDepositRoute: OnboardingGuardedDepositRoute,
  OnboardingGuardedDriversLicenseRoute: OnboardingGuardedDriversLicenseRoute,
  OnboardingGuardedEmailVerifiedRoute: OnboardingGuardedEmailVerifiedRoute,
  OnboardingGuardedFinalRoute: OnboardingGuardedFinalRoute,
  OnboardingGuardedFormulaRoute: OnboardingGuardedFormulaRoute,
  OnboardingGuardedFormulaConfigRoute: OnboardingGuardedFormulaConfigRoute,
  OnboardingGuardedIdentityRoute: OnboardingGuardedIdentityRoute,
  OnboardingGuardedLegalRoute: OnboardingGuardedLegalRoute,
  OnboardingGuardedPhoneRoute: OnboardingGuardedPhoneRoute,
  OnboardingGuardedPhoneVerifyRoute: OnboardingGuardedPhoneVerifyRoute,
}

const OnboardingGuardedRouteWithChildren =
  OnboardingGuardedRoute._addFileChildren(OnboardingGuardedRouteChildren)

interface OnboardingRouteChildren {
  OnboardingGuardedRoute: typeof OnboardingGuardedRouteWithChildren
  OnboardingAccountRoute: typeof OnboardingAccountRoute
  OnboardingEmailVerifyRoute: typeof OnboardingEmailVerifyRoute
  OnboardingStartRoute: typeof OnboardingStartRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingGuardedRoute: OnboardingGuardedRouteWithChildren,
  OnboardingAccountRoute: OnboardingAccountRoute,
  OnboardingEmailVerifyRoute: OnboardingEmailVerifyRoute,
  OnboardingStartRoute: OnboardingStartRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
